var map = {
	"./Handshake.png": "4d31",
	"./ITsoftware.png": "edf4",
	"./activity.png": "68ad",
	"./agri.png": "42fb",
	"./building-head.png": "ac50",
	"./coin.png": "2912",
	"./company.png": "d2ba",
	"./contacts-line.png": "c030",
	"./eco.png": "0a07",
	"./energy.png": "d28bc",
	"./energy2.png": "e716",
	"./frame-camera.png": "4c03",
	"./graph-star.png": "086f",
	"./hand-coin-line.png": "92f5",
	"./health.png": "515a",
	"./job-creation.png": "a3ed",
	"./judge.png": "5bdc",
	"./line-chart-fill.png": "d421",
	"./map-organ.png": "e3ee",
	"./med.png": "f32f",
	"./medical.png": "5e10",
	"./organization.png": "4b6f",
	"./organization2.png": "5ea5",
	"./others.png": "05a3",
	"./pie-chart-line.png": "4781",
	"./ranking.png": "f345",
	"./refund-2-line.png": "62ee",
	"./trend-up.png": "3da2",
	"./truck.png": "2cdd",
	"./up.png": "55a9"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "3a59";